import React from "react";

import reunion from "../assets/img/reunion.png";
import "../assets/css/quienesSomos.css";
import documenCheck from "../assets/svg/document-check.svg";
import check from "../assets/svg/check.svg";
import heads from "../assets/svg/hands.svg";
import service from "../assets/svg/service-setting.svg";
import security from "../assets/svg/security.svg";
import idea from "../assets/svg/lightbulb.svg";
import { ReactComponent as CheckMision } from "../assets/svg/checkMision.svg";
import { ReactComponent as FlechaVision } from "../assets/svg/flechaVision.svg";
import { ReactComponent as OjoVision } from "../assets/svg/ojoVision.svg";

const QuienesSomos = () => {
  return (
    <div className="contenedor-principal">
      <div className="contenedor-secundario">
        <div className="subContenedor">
          <div className="fila1">
            <h2 className="texto1">¿Quiénes Somos?</h2>
            <p className="texto2">
              TORRES & TORRES es una empresa fundada en 2004, respaldada por la
              trayectoria de más de 24 años del Dr. Juan de Dios Rafael Torres
              Durand y de más de 32 años del Econ. Alejandro Fabián Torres
              Durand. Ofrece asesoría legal y financiera, respaldada por el
              desarrollo profesional conjunto de sus socios y colaboradores. Su
              enfoque en la entrega de resultados ha propiciado el
              reconocimiento y la confianza de sus clientes.
            </p>
          </div>
          <div className="fila2">
            <img src={reunion} alt="Reunión de equipo" />
          </div>
        </div>
      </div>

      <div className="contenedor-mision-vision">
        <div className="contenedorSecundario-mision-vision">
          <div className="color-fondo">
            <div className="fila-mision-vision">
              <div className="tarjeta-mision">
                <div className="titulos">
                  <div className="check">
                    <CheckMision className="checkMision" />
                    <h2>Misión</h2>
                  </div>
                  <div className="flechaVision">
                    <FlechaVision className="flecha-icono" />
                  </div>
                </div>
                <p>
                  Brindar asesoramiento, representación, patrocinio y defensa a
                  nuestros clientes, personas naturales y jurídicas, nacionales
                  y extranjeras, con la finalidad de maximizar el funcionamiento
                  de su organización, estableciendo con nuestros clientes una
                  relación que les permita lograr sus fines de una manera
                  rápida, eficiente y rentable.
                </p>
              </div>

              <div className="tarjeta-vision">
                <div className="titulos">
                  <div className="check">
                    <OjoVision className="OjoVision"/>
                    <h2>Visión</h2>
                  </div>
                  <div className="flechaVision">
                    <FlechaVision className="flecha-icono" />
                  </div>
                </div>
                <p>
                  Establecernos como una organización líder en el mercado de
                  servicios de asesoramiento empresarial, ser reconocidos como
                  los mejores en las labores realizadas, comprometidos con
                  nuestros clientes en el servicio, en base a un crecimiento
                  compartido entre nuestra organización y la de nuestros
                  clientes, desarrollando una simbiosis de calidad y mejora
                  constante, que nos permita prevenir y solucionar no solo
                  situaciones de conflicto, sino ir de la mano en el desarrollo
                  de sus actividades empresariales, diseñando con ellos
                  escenarios favorables de desarrollo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sección de Valores */}
      <div className="contendor-valores-web">
        <h2 className="titulo-valores">Nuestros Valores</h2>
        <div className="contenedor-valores">
          <div className="filaValor">
            <div className="valor">
              <img src={documenCheck} alt="Check" />
              <h3>TRANSPARENCIA</h3>
              <p>
                En el servicio al cliente, a quien en todo momento se le debe
                tener correctamente informado de su problemática, sus
                proyecciones, escenarios, y alcance de metas fijadas.
              </p>
            </div>

            <div className="valor">
              <img src={service} alt="Service" />
              <h3>EFICIENCIA</h3>
              <p>
                Empleando los medios adecuados para el cumplimiento de los fines
                y metas planteadas en el servicio brindado a nuestros clientes.
              </p>
            </div>

            <div className="valor">
              <img src={heads} alt="Handshake" />
              <h3>LEALTAD</h3>
              <p>
                En el servicio que implica cumplir con lo prometido o informado
                al cliente, y velar en obtener siempre el mejor resultado para
                sus intereses en el servicio que se brinda.
              </p>
            </div>
          </div>

          {/* Segunda fila */}
          <div className="filaValor2">
            <div className="valor">
              <img src={security} alt="Security" />
              <h3>EFICACIA</h3>
              <p>
                Conseguir los fines, objetivos, metas trazados por nuestros
                clientes, nuestra actividad empresarial va de la mano con el
                logro de resultados cuantificables y cualificables.
              </p>
            </div>

            <div className="valor">
              <img src={check} alt="Quality" />
              <h3>CONFIDENCIALIDAD</h3>
              <p>
                En todo asunto, negocio, o tema relacionado con nuestros
                clientes, lo cual permite generar y mantener la confianza mutua
                y una relación duradera.
              </p>
            </div>

            <div className="valor">
              <img src={idea} alt="Idea" />
              <h3>COMPROMISO</h3>
              <p>
                Compromiso con nuestros clientes, compromiso con el cumplimiento
                de las metas, objetivos y planes de nuestros clientes,
                respetando siempre los acuerdos arribados con ellos.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="contenedor-valores-movil">
        <h2 className="titulo-valores">Nuestros Valores</h2>

        <div className="filaMobile">
          <div className="wrapper-valor derecha">
            <div className="valor">
              <img src={documenCheck} alt="Check" />
              <h3>TRANSPARENCIA</h3>
              <p>En el servicio al cliente, a quien en todo momento se le debe tener correctamente informado de su problemática, sus proyecciones, escenarios, y alcance de metas fijadas.</p>
            </div>
          </div>

          <div className="wrapper-valor izquierda">
            <div className="valor">
              <img src={service} alt="Service" />
              <h3>EFICIENCIA</h3>
              <p>Empleando los medios adecuados para el cumplimiento de los fines y metas planteadas en el servicio brindado a nuestros clientes.</p>
            </div>
          </div>
        </div>

        <div className="filaMobile">
          <div className="wrapper-valor derecha">
            <div className="valor">
              <img src={heads} alt="Handshake" />
              <h3>LEALTAD</h3>
              <p>En el servicio que implica cumplir con lo prometido o informado al cliente, y velar en obtener siempre el mejor resultado para sus intereses en el servicio que se brinda.</p>
            </div>
          </div>

          <div className="wrapper-valor izquierda">
            <div className="valor">
              <img src={security} alt="Security" />
              <h3>EFICACIA</h3>
              <p>Conseguir los fines, objetivos, metas trazados por nuestros clientes, nuestra actividad empresarial va de la mano con el logro de resultados cuantificables y cualificables.</p>
            </div>
          </div>
        </div>

        <div className="filaMobile">
          <div className="wrapper-valor derecha">
            <div className="valor">
              <img src={check} alt="Quality" />
              <h3>CONFIDENCIALIDAD</h3>
              <p>En todo asunto, negocio, o tema relacionado con nuestros clientes, lo cual permite generar y mantener la confianza mutua y una relación duradera.</p>
            </div>
          </div>

          <div className="wrapper-valor izquierda">
            <div className="valor">
              <img src={idea} alt="Idea" />
              <h3>COMPROMISO</h3>
              <p>Compromiso con nuestros clientes, compromiso con el cumplimiento de las metas, objetivos y planes de nuestros clientes, respetando siempre los acuerdos arribados con ellos.</p>
            </div>
          </div>
        </div>
      </div>

      <section className="contenedor-politicas">
        <header className="titulo-politicas">
          <h2>Nuestras Políticas</h2>
        </header>

        <div className="fila-politicas">
          <article className="tarjeta-politica primera">
            <div className="titulos-politicas">
              <h3>DE CALIDAD</h3>
              <FlechaVision className="flechaPoliticas" />
            </div>
            <p>
              Siendo los mejores en nuestras áreas de especialización, podemos
              brindar el mejor servicio al cliente, para ello el compartir en
              directorio las experiencias mutuas, conferenciar y buscar
              soluciones conjuntas a las problemáticas que se nos presenta,
              favorecer la capacitación contante de nuestros colaboradores son
              algunas de las herramientas que nos permite superarnos a nosotros
              mismos.
            </p>
          </article>
          <article className="tarjeta-politica">
            <div className="titulos-politicas">
              <h3>DE DESARROLLO COMPARTIDO</h3>
              <FlechaVision className="flechaPoliticas" />
            </div>
            <p>
              Apoyarnos permanentemente en nuestros compañeros a fin de
              encontrar mejoras en la labor y el servicio a nuestros clientes,
              apoyar el crecimiento de nuestros clientes porque en la medida de
              crecimiento, nuestra organización crece con ellos, así como en la
              medida que nuestra organización crece, beneficiamos el crecimiento
              de nuestros clientes.
            </p>
          </article>
        </div>
      </section>
    </div>
  );
};
export default QuienesSomos;
